import { VoiceOrbState } from './ui.voice-orb';

interface VoiceOrbStateParams {
  isSessionOver: boolean;
  isSubmitting: boolean;
  isSpeaking: boolean;
  isListening: boolean;
  isStarting?: boolean;
  audioLevel: number;
}

export function getVoiceOrbState({
  isSessionOver,
  isSubmitting,
  isSpeaking,
  isListening,
  isStarting = false,
  audioLevel,
}: VoiceOrbStateParams): VoiceOrbState {
  if (isSessionOver) {
    return 'user-idle';
  }
  if (isSubmitting) {
    return 'ai-thinking';
  }
  if (isSpeaking) {
    return 'ai-talking';
  }
  if (isStarting && !isListening) {
    return 'user-idle';
  }
  if (isListening && audioLevel > 0.05) {
    return 'user-talking';
  }

  return 'user-idle';
}
